import React, { useState, useEffect, useMemo } from 'react';
import DataTable from 'react-data-table-component';
const utils = require('../components/utils');

const LOADING = 'Loading...';
const baseUrl = `${window.nobid_endpoint}/carbon/pubreports_top_sites`;


const columnsTopSites = [
  { name: 'Publisher', selector: 'publisher_name', sortable: true },
  { name: 'Site', selector: 'site_name', sortable: true },
  { name: '#Impressions', selector: 'impressions', sortable: true, cell: row => <span>{ utils.formatLong(row.impressions) }</span>, definition: 'Impressions served.' },
  { name: '$Revenue', selector: 'revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.revenue) }</span>, definition: 'Revenue generated by the impression in the currency defined in the Prebid wrapper.' }
];
let dataTopSites = [];
const DashboardTopSitesComponent = ({params, parentLoading}) => {
  const [loading, setLoading] = useState(true);

  const updateState = (results) => {
    const data = [];
    if (results) results.forEach( r => {
      data.push({publisher_name: r.publisher_name, site_name: r.site_name, impressions: r.impressions, revenue: r.revenue});
    });
    dataTopSites = data;
    setLoading(false);
  }

  const getData = () => {
    setLoading(true);
    const p = params.filter(x => !x.startsWith('_sort=') && !x.startsWith('_end=') && !x.startsWith('_order='));
    p.push('_sort=revenue');
    p.push('_end=30');
    p.push('_order=DESC');
    p.push('show=publisher');
    p.push('show=site');
    let url = `${baseUrl}?${p.join('&')}`;
    let options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then((response) => {
      return response.json();
    }).then((results) => {
      updateState(results);
    });
  }

  useEffect(() => { if (parentLoading) getData() }, [parentLoading]);
 
  return (
    <div style={{position: 'relative'}}>
      <DataTable
        title="Top Sites"
        theme="dark"
        columns={columnsTopSites}
        data={dataTopSites}
        progressPending={loading}
        pagination
        fixedHeader
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        dense
        highlightOnHover
      />
    </div>
  )
}

export default DashboardTopSitesComponent;
